import React, { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import type { SubscriptionActivityView } from '../data/mockSubscriptionActivity';
interface ActivityViewsDropdownProps {
  views: SubscriptionActivityView[];
  activeViewId: string | null;
  onSelect: (view: SubscriptionActivityView) => void;
}
export function ActivityViewsDropdown({
  views,
  activeViewId,
  onSelect
}: ActivityViewsDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const activeView = views.find(view => view.id === activeViewId) ?? null;
  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);
  return <div className="relative" ref={ref} data-id="element-117" data-mp="19t0x6umm2cb7">
      <button type="button" onClick={() => setOpen(value => !value)} aria-haspopup="menu" aria-expanded={open} className="inline-flex items-center gap-2 h-12 px-4 border border-[#CBD5E1] rounded-md bg-white text-sm font-medium text-[#475569] hover:bg-[#F8FAFC] hover:text-[#0F172A] transition-all duration-200 max-w-[240px]" data-id="element-118" data-mp="w01iguunkm4p">
        <span className="truncate" data-id="element-119" data-mp="r185r4n6wz5l">{activeView ? activeView.name : 'Views'}</span>
        <ChevronDown className="w-4 h-4 flex-shrink-0" data-id="element-120" data-mp="d1pavdje3kb8" />
      </button>

      {open && <div role="menu" className="absolute right-0 top-full mt-1 w-64 bg-white border border-[#E2E8F0] rounded-lg shadow-lg z-30 py-1" data-id="element-121" data-mp="hz8n67wj1n0j">
          <div className="px-3 pt-1.5 pb-1 text-[11px] font-semibold text-[#94A3B8] uppercase tracking-wider" data-id="element-122" data-mp="27f844b6e0gqq">
            Views
          </div>
          {views.map(view => <button key={view.id} type="button" role="menuitemradio" aria-checked={view.id === activeViewId} onClick={() => {
        onSelect(view);
        setOpen(false);
      }} className="w-full flex items-center justify-between gap-2 px-3 py-2 text-left text-sm text-[#0F172A] hover:bg-[#F8FAFC]" data-id="element-123" data-mp="29zmm4e2v1ik2">
              <span data-id="element-124" data-mp="1w054cinzf5k7">{view.name}</span>
              {view.id === activeViewId && <Check className="w-4 h-4 text-[#0EA5E9] flex-shrink-0" data-id="element-125" data-mp="2tn42kxubolk7" />}
            </button>)}
          <div className="my-1 h-px bg-[#E2E8F0]" data-id="element-126" data-mp="2towypj7b7ndy" />
          <button type="button" role="menuitem" onClick={() => setOpen(false)} className="w-full px-3 py-2 text-left text-sm text-[#475569] hover:bg-[#F8FAFC]" data-id="element-127" data-mp="2op2c3rukhjyp">
            Save current view…
          </button>
          <button type="button" role="menuitem" onClick={() => setOpen(false)} className="w-full px-3 py-2 text-left text-sm text-[#475569] hover:bg-[#F8FAFC]" data-id="element-128" data-mp="2exofbru02y99">
            Manage views
          </button>
        </div>}
    </div>;
}